import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { EntityMembershipPolicies } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { COLLECTIONS_QUERY_KEY } from "./useCollections";
const getDefaultUserConnection = async ({ id }) => EntityMembershipPolicies.loadPermittedDefaultCollections(id);
const useUserDefaultCollections = (userId, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [COLLECTIONS_QUERY_KEY, "user", userId],
    queryFn: () => defaultOnError(
      getDefaultUserConnection({ id: userId }),
      i18n.t("notifications.fetch_user_default_collections_failed", { ns: "enterprise_collections" }),
      i18n.t("notifications.fetch_user_default_collections_failed_title", { ns: "enterprise_collections" })
    ),
    enabled
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useUserDefaultCollections;
